import {
  Alert,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  REGISTER_MANAGER,
  GET_CURRENT_MANAGER,
  GET_MANAGERS,
} from "../../GraphQL/Managers";
import useNotification from "../../hooks/useNotification.js";

const RegisterManagerDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [registerManager, { loading, error }] = useMutation(REGISTER_MANAGER, {
    refetchQueries: [GET_CURRENT_MANAGER, GET_MANAGERS],
    onCompleted: () => { notifySuccess("Registered as manager."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            registerManager();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Register as Manager"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>Manager</DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveRegisterManagerDialogButton"
            variant="contained"
            onClick={() => registerManager()}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Register as Manager"
            )}
          </Button>
          <Button
            data-testid="closeRegisterManagerDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default RegisterManagerDialog;
